export interface IPublicTypeDisposable {
  (): void;
}